import desctopFirst from '../image/BannerImage/desctop-first.webp';
import desctopSecond from '../image/BannerImage/desctop-second.webp';
import desctopThird from '../image/BannerImage/desctop-third.webp';
import firstMobile from '../image/BannerImage/first-mobile.webp';
import secontMobile from '../image/BannerImage/socond-mobile.webp';
import thirdMobile from '../image/BannerImage/third-mobile.webp';

export const desktopBanner = [
  {
    src: desctopFirst,
  },
  {
    src: desctopSecond,
  },
  {
    src: desctopThird,
  },
];

export const mobileBanner = [
  {
    src: firstMobile,
  },
  {
    src: secontMobile,
  },
  {
    src: thirdMobile,
  },
];
